<template>
    <div>
        <div class="popup-active" v-if="showInside">
            <div class="popup-form" v-click-outside="closeEvent">
                <header class="popup-title">
                    <h2>Spara i veckomeny</h2>
                    <svg @click="hide" class="icon popup-close">
                        <use xlink:href="#icon-close"></use>
                    </svg>
                </header>
                <form id="add-recipe-to-menu" method="POST" v-on:submit.prevent="submitForm" v-if="!prompt">
                    <label>Välj vilken veckomeny du vill spara receptet i</label>

                    <div class="form-group">
                        <select v-model="selectedMenu" class="input-select"
                            v-bind:class="{ 'is-invalid': attemptSubmit && missingMenu }">
                            <option disable>Välj bland befintliga</option>
                            <option v-for="(list, index) in menus" v-bind:value="index">
                                {{ list.title }}
                            </option>
                        </select>
                    </div>

                    <table class="table-container table-interactive add-recipe-to-menu-table">
                        <thead class="header">
                            <tr>
                                <th class="table--day">Dag</th>
                                <th class="table--time">Klockslag</th>
                                <th class="table--meal center-sm-sm">Måltid</th>
                                <th class="table--title">Titel</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="row in rows" track-by="$index" class="table--tr">
                                <td class="table--td-day center-sm" data-th="Dag">
                                    <div class="table--day">
                                        <input type="number" name="day" v-model="row.day"
                                            class="form-control no-spinners"
                                            v-bind:class="{ 'is-invalid': attemptSubmit && missingDay }" />
                                    </div>
                                </td>
                                <td class="table--td-time center-sm" data-th="Klockslag">
                                    <div class="table--time">
                                        <input type="time" name="time" v-model="row.time" class="form-control"
                                            v-bind:class="{ 'is-invalid': attemptSubmit && missingTime }" />
                                    </div>
                                </td>
                                <td class="table--td-meal center-sm" data-th="Måltid">
                                    <div class="table--meal">
                                        <select name="type" v-model="row.type" class="input-select"
                                            v-bind:class="{ 'is-invalid': attemptSubmit && missingType }">
                                            <option value="1">Frukost</option>
                                            <option value="2">Mellanmål 1</option>
                                            <option value="3">Lunch</option>
                                            <option value="4">Mellanmål 2</option>
                                            <option value="5">Middag</option>
                                            <option value="6">Mellanmål 3</option>
                                            <option value="7">Kvällsmat</option>
                                            <option value="8">Övrigt</option>
                                        </select>
                                    </div>
                                </td>
                                <td class="table--td-title" data-th="Titel">
                                    <div class="table--title">
                                        <input type="text" name="title" v-model="row.title" class="form-control"
                                            v-bind:class="{ 'is-invalid': attemptSubmit && missingTitle }" />
                                    </div>
                                </td>
                                <td class="action-add-remove">
                                    <svg class="icon add-instruction" @click="addRow($index)">
                                        <use xlink:href="#icon-plus"></use>
                                    </svg>
                                </td>
                                <td class="action-add-remove">
                                    <svg id="icon-minus" viewBox="0 0 20 20" width="100%" height="100%"
                                        @click="removeRow($index, rows.length)">
                                        <path d="M10,1.6c-4.639,0-8.4,3.761-8.4,8.4c0,4.639,3.761,8.4,8.4,8.4s8.4-3.761,8.4-8.4C18.4,5.361,14.639,1.6,10,1.6z M15,11H5V9
                                        h10V11z"></path>
                                    </svg>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <input type="hidden" name="menu_id" :value="selectedMenuId" />
                    <input type="hidden" name="recipe_id" :value="recipeId" />

                    <button class="btn btn-primary">Spara i veckomeny</button>
                </form>
                <span v-if="prompt">{{ prompt }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import state from './../state.js';

export default {
    props: ['isRecipeAdmin', 'recipeId'],

    data() {
        return {
            state,
            showInside: false,
            selectedMenu: 'Välj bland befintliga',
            menus: [],
            baseUrl: window.appConfig.public_url,
            prompt: false,
            attemptSubmit: false,
            rows: [
                {
                    title: '',
                    type: 1,
                    day: '',
                    time: ''
                }
            ],
            currentEvent: null
        };
    },

    mounted() {
        this.getMenus();
    },

    directives: {
        'click-outside': {
            priority: 700,

            bind: function (el, binding, vnode) {
                let self = vnode.context;

                self.currentEvent = function (event) {
                    self.closeEvent(event);
                };

                el.addEventListener('click', (event) => event.stopPropagation());

                document.body.addEventListener('click', self.currentEvent);

                $('body').addClass('lock');
            },

            unbind: function (el, binding, vnode) {
                el.removeEventListener('click', (event) => event.stopPropagation());

                document.body.removeEventListener('click', self.currentEvent);

                $('body').removeClass('lock');
            }
        }
    },

    computed: {
        menuForm: function () {
            return this.state.menuForm;
        },

        selectedMenuId: function () {
            if (this.menus[this.selectedMenu]) {
                return this.menus[this.selectedMenu].id;
            }
            return null;
        },

        missingMenu: function () {
            if (this.selectedMenu == 'Välj bland befintliga') {
                return true;
            }

            return false;
        },

        missingDay: function () {
            if (this.day == '') {
                return true;
            }

            return false;
        },

        missingType: function () {
            if (this.type == '') {
                return true;
            }

            return false;
        },

        missingTitle: function () {
            if (this.title == '') {
                return true;
            }

            return false;
        },

        missingTime: function () {
            if (this.time == '') {
                return true;
            }

            return false;
        },

        promptSuccess: function () {
            return 'Receptet har lagts till i veckomenyn.';
        },

        promptError: function () {
            return 'Något gick fel! Försök igen.';
        },

        validateFields: function () {
            return (
                !this.missingMenu &&
                !this.missingTime &&
                !this.missingTitle &&
                !this.missingType &&
                !this.missingDay
            );
        }
    },

    watch: {
        menuForm: function (newVal) {
            newVal ? this.show() : '';
        }
    },

    methods: {
        show() {
            this.showInside = true;
        },

        hide() {
            this.prompt = false;
            this.showInside = false;
            this.state.menuForm = false;
            this.selectedMenu = 'Välj bland befintliga';
            this.attemptSubmit = false;
            this.rows = [
                {
                    title: '',
                    type: 1,
                    day: '',
                    time: ''
                }
            ];
        },

        getMenus() {
            axios
                .get('/recept/api/menus/list')
                .then((response) => {
                    this.menus = response.data;
                })
                .catch((error) => { });
        },

        submitForm(e) {
            this.attemptSubmit = true;
            if (!this.validateFields) return;
            axios
                .post('/recept/api/menu/' + this.selectedMenuId + '/add/recipe/' + this.recipeId, {
                    form_data: this.rows
                })
                .then((response) => {
                    if (response.status == 200) {
                        this.prompt = this.promptSuccess;
                    }
                })
                .catch((error) => {
                    if (error) {
                        this.error = this.promptError;
                    }
                });
        },
        addRow(index) {
            try {
                this.rows.splice(index + 1, 0, {
                    title: this.rows[index].title,
                    type: this.rows[index].type,
                    day: '',
                    time: this.rows[index].time
                });
            } catch (e) {
                console.log(e);
            }
        },
        removeRow: function (index, length) {
            if (length > 1) {
                this.rows.splice(index, 1);
            }
        },

        closeEvent() {
            this.hide();
            this.attemptSubmit = false;
        }
    }
};
</script>
